/*
 * @Author: handan05
 * @Date: 2022-07-28 11:21:05
 * @LastEditors: handan05 handan05@58.com
 * @LastEditTime: 2023-11-06 20:17:29
 * @FilePath: /zcm_step_nodeserver/Users/handan/Documents/handan_work/58work/58project/tech/wblog/src/platforms/zcm.ts
 * @Description:
 */
import { ReportParams } from '../types';
import zcmLog from './zcm-old';
import { processReportParams } from '../utils/processAppParams';

/**
 * 触发埋点
 * @param {*} reportParams
 */
function log(reportParams: ReportParams) {
    const { options = {} } = reportParams || {};

    // 为zcm端设置默认的bizLine值
    const zcmParams = {
        ...reportParams,
        options: {
            ...options,
            bizLine: options.bizLine || 'job_business_speed'
        }
    };

    const { opt, p } = processReportParams(zcmParams);

    if (!opt) return;

    const hostApp = (<any>window).ZCMAPP || (<any>window).ZPAPP;

    if (hostApp) {
        return hostApp.invoke('job_weblog', opt);
    } else {
        // 调用老版本埋点上报api
        return zcmLog({ opt, p });
    }
}

export default log;
